/** Shared by server validation, edit projection, and the browser editor.
 * Exceptions come from verified Oracle text, never a card-name allowlist.
 */
export interface CopyLimitCard {
  name: string;
  oracle_text?: string | null;
}

export const BASIC_LANDS = new Set([
  "Plains", "Island", "Swamp", "Mountain", "Forest", "Wastes",
  "Snow-Covered Plains", "Snow-Covered Island", "Snow-Covered Swamp",
  "Snow-Covered Mountain", "Snow-Covered Forest",
]);

const BASIC_LAND_KEYS = new Set([...BASIC_LANDS].map((name) => name.toLowerCase()));

function normalize(value: string): string {
  return value.trim().replace(/[’‘]/g, "'").replace(/\s+/g, " ").toLowerCase();
}

const NUMBER_WORDS: Record<string, number> = {
  one: 1, two: 2, three: 3, four: 4, five: 5, six: 6,
  seven: 7, eight: 8, nine: 9, ten: 10,
};

/** Infinity means no per-name copy cap; deck size, legality and ownership still apply. */
export function cardCopyLimit(card: CopyLimitCard, format = "standard"): number {
  if (BASIC_LAND_KEYS.has(normalize(card.name))) {
    return Infinity;
  }
  const text = normalize(card.oracle_text ?? "");
  const unlimited = text.match(/(?:^|[.\n]\s*)a deck can have any number of cards named ([^.]+)\./);
  if (unlimited && normalize(unlimited[1]!) === normalize(card.name)) return Infinity;
  const capped = text.match(/(?:^|[.\n]\s*)a deck can have up to (\d+|[a-z]+) cards named ([^.]+)\./);
  if (capped && normalize(capped[2]!) === normalize(card.name)) {
    const count = NUMBER_WORDS[capped[1]!] ?? Number(capped[1]);
    if (Number.isSafeInteger(count) && count > 0) return count;
  }
  return format === "commander" ? 1 : 4;
}
